<template>
    <el-container>
        <el-container>
            <el-header style="text-align: left;height: 80px;padding-top: 20px;font-size: 12px;" class="alarm-device-classify-head">
                <el-container style="height: 50px;">
                    <td-radio v-model="storagePolicyType" @change="getStoragePolicy" :options="storagePolicyOptions" border></td-radio>
                </el-container>
            </el-header>
            <el-main>
                <el-form :model="formInfo" ref="formInfo" label-position="right" :label-width="formLabelWidth">
                    <el-row :gutter="10">
                        <el-col :span="8">
                            <el-form-item :label="$t('common.STORAGE_POLICE_ABLE')" ref="status">
                                <td-radio v-model="isAble" :options="isAbleOptions"></td-radio>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item :label="$t('common.STORAGE_DAY')" :labelWidth="formLabelWidth" v-show="timeShow">
                                <td-inputNumber v-model="formInfo.timeValue" :min="1" :max="365"></td-inputNumber>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <td-dynamic ref="tdDynamic" :groupFlg="groupFlg" v-model="groupElementValue"></td-dynamic>
                    </el-row>
                </el-form>
                <td-button type="primary" :loading="saveLoading" :permissions="permissionsSave" @click="submit('formInfo')">{{ $t('common.SAVE') }}</td-button>
            </el-main>
        </el-container>
    </el-container>
</template>

<script>
import api from './assets/api.js';
export default {
    // 在页面渲染完成之后进行初始化工作
    mounted() {
        this.getAllStoragePolicy();
        this.getStoragePolicy(); // 进行页面初始化数据的加载
    },
    // 定义数据
    data() {
        return {
            permissionsSave: ['storagePolicy:save'],
            groupFlg: '',
            groupElementValue: {},
            storagePolicyOptions: [],
            isAbleOptions: [{ value: false, label: this.$t('common.NOT') }, { value: true, label: this.$t('common.YES') }],
            storagePolicyType: 1,
            isAble: false,
            sId: '',
            saveLoading: false,
            formInfo: { timeValue: 1 },
            formLabelWidth: '15%',
            timeShow: true
        };
    },
    // 方法的实现
    methods: {
        showTime(type) {
            if (type === 1 || type === 2) {
                this.timeShow = true;
            } else {
                this.timeShow = false;
            }
        },
        // 获取策略模块信息
        getAllStoragePolicy() {
            let param = {};
            api.getAllStoragePolicy(param, response => {
                if (null === response || null === response.data) {
                    return;
                }

                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('alarm/getStoragePolicy', response.data.statusMessage);
                    return;
                }
                var content = response.data.content;
                if (null === content || content.length === 0) {
                    this.$message({ showClose: true, message: this.$t('error.ERROR_NOT_CONFIG_INFO'), type: 'error' });
                    return;
                }
                for (var i = 0; i < content.length; i++) {
                    let params = {};
                    params.value = content[i].iType;
                    params.label = content[i].sCaption;
                    this.storagePolicyOptions.push(params);
                }
                this.storagePolicyType = content[0].iType;
                this.showTime(this.storagePolicyType);
                if (content[0].sExtendGroupFlag !== null) {
                    this.groupFlg = content[0].sExtendGroupFlag;
                }
                if (content[0].sExtendInfo !== null) {
                    this.groupElementValue = content[0].sExtendInfo;
                }
            });
        },
        // 查询数据
        getStoragePolicy() {
            this.showTime(this.storagePolicyType);
            this.sId = '';
            let param = {
                iType: this.storagePolicyType
            };
            api.getStoragePolicy(JSON.stringify(param), response => {
                if (null === response || null === response.data) {
                    return;
                }
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    return;
                }
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('alarm/getStoragePolicy', response.data.statusMessage);
                    return;
                }
                //初始化
                this.formInfo.timeValue = 1;
                let storagePolicy = response.data.content;
                if (storagePolicy) {
                    this.isAble = storagePolicy.iTimeStatus !== 0;
                    this.formInfo.timeValue = storagePolicy.iTimeValue;
                    this.sId = storagePolicy.sId;
                    this.groupFlg = storagePolicy.sExtendGroupFlag;
                    this.groupElementValue = JSON.parse(storagePolicy.sExtendInfo.replace(/\\/g, ''));
                }
            });
        },
        // 提交数据
        submit() {
            let dynamicCheck = true;
            if (this.groupFlg) {
                this.$refs.tdDynamic.$refs.dynamicForm.validate(validDynamic => {
                    dynamicCheck = validDynamic;
                });
            }
            if (dynamicCheck) {
                let extendInfos = {};
                if (this.groupFlg) {
                    extendInfos = this.$refs.tdDynamic.getfromInfo();
                }
                this.saveLoading = true;
                let content = {
                    iType: this.storagePolicyType,
                    iTimeValue: this.formInfo.timeValue,
                    iTimeStatus: this.isAble ? '1' : '0',
                    sId: this.sId,
                    sExtendInfo: JSON.stringify(extendInfos)
                };
                api.saveStoragePolicy(JSON.stringify(content), response => {
                    this.saveLoading = false;
                    if (null === response || null === response.data) {
                        return;
                    }
                    if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                        this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                        this.$log.error('alarm/saveStoragePolicy', response.data.statusMessage);
                        return;
                    }
                    this.$message({ showClose: true, message: this.$t('common.SAVE_SUCCESS'), type: 'success' });
                });
            }
        }
    }
};
</script>
